import { useNavigate } from "@tanstack/react-router";
import { type ReactNode, useState } from "react";

import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { mutationResponse } from "@/utils/trpc";

export function DeleteClientDialog({
  org,
  children,
}: {
  org: { id: number };
  children: ReactNode;
}) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const deleteOrg = trpc.admin.org.delete.useMutation();

  const confirm = () => {
    deleteOrg.mutate(
      { id: org.id },
      mutationResponse({
        errorTitle: "Error deleting client",
        successMessage: "Client deleted",
        onSuccess() {
          navigate({ to: "/admin/clients" });
        },
      }),
    );
  };

  return (
    <ConfirmPrompt
      open={open}
      onOpenChange={setOpen}
      onConfirm={confirm}
      title="Delete client"
      message="Are you sure you want to delete this client?"
      loading={deleteOrg.isPending}
      danger
    >
      {children}
    </ConfirmPrompt>
  );
}
